import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
 
import PageTopTitle from "../../components/shared/PageTopTitle";
import Button from "../../components/shared/button/Btn";
import { useState } from "react";
import { showModal } from "../../features/modal/modalSlice";
import SmallSpinner from "../../components/shared/spinners/SmallSpinner";
import {
  getAracCezaSorgu,
  getAracMuayeneSorgu,
  getAracYetkiBelgesiSorgu,
} from "../../features/uyelerAraclar/uyelerAraclarSlice";
import InputGroup from "../../components/shared/InputGroup";
const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      margin: 40px 30px;
      display: flex;
      width: auto;
      flex-direction: column;
      @media (max-width: 1550px) {
        margin: 0;
        padding: 40px 30px;
        width: 100%;
      }
      .container {
        margin-top: 40px;
        width: auto;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: 20px;
        @media (max-width: 1550px) {
          width: 100%;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr 1fr;
        }
        .grp {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 10px;
          width: 240px;
          @media (max-width: 1550px) {
            width: 100%;
            button {
              width: 100%;
              line-height: initial;
            }
          }

          &:first-child {
            width: auto;
          }

          p {
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            text-align: center;
            color: ${({ theme }) => theme.mainTextColor};
          }
        }
      }

      .toplu-excel-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 30px 40px;
        border-radius: 10px;
        margin: 0 auto;
        margin-top: 40px;

        width: max-content;
        background-color: ${({ theme }) => theme.secondaryBgColor};

        h3 {
          font-size: var(--font-size-lg);
          font-weight: var(--font-weight-xl);
          margin-bottom: 45px;
          color: ${({ theme }) => theme.mainTextColor};
        }

        .input-grp {
          display: flex;
          align-items: center;

          .file-input-label {
            width: 160px;
            padding: 0 10px;
            line-height: 40px;
            text-align: center;
            height: 40px;
            background-color: ${({ theme }) => theme.utilityBtnBg};
            color: #fff;
            border-radius: 10px;
            border: 1px solid;
            cursor: pointer;
            border-color: ${({ theme }) => theme.mainBorderColor};
          }

          .file-name {
            font-size: 16px;
            font-weight: var(--font-weight-lg);
            color: ${({ theme }) => theme.mainTextColor};
            padding: 0 20px;
          }

          .file-input {
            display: none;
          }
        }
      }
    }
  }
`;

const AraçYetkiBelgeSorgulamaUyelerVeAraclar = () => {
  const dispatch = useDispatch();

  const {
    isLoadingGetAracMuayeneSorgu,
    isLoadingGetAracCezaSorgu,
    isLoadingGetAracYetkiSorgu,
  } = useSelector((state) => state.uyelerAraclar);

  const [plaka, setPlaka] = useState("");

  const [file, setFile] = useState("");

  const handleYetkiSorgula = () => {
    if (plaka) {
      const newPlaka = plaka.replace(/\s/g, "");
      dispatch(getAracYetkiBelgesiSorgu(newPlaka));
      dispatch(showModal("aracYetkiBelgesiSorgu"));
    }
  };

  const handleMuayeneSorgula = () => {
    if (plaka) {
      const newPlaka = plaka.replace(/\s/g, "");
      dispatch(getAracMuayeneSorgu(newPlaka));
      dispatch(showModal("aracMuayeneSorgu"));
    }
  };

  const handleCezaSorgula = () => {
    if (plaka) {
      const newPlaka = plaka.replace(/\s/g, "");
      dispatch(getAracCezaSorgu(newPlaka));
      dispatch(showModal("aracCezaSorgu"));
    }
  };

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Araç Yetki Belge Sorgulama"} position="sticky" />
        <div className="content">
          <div className="container">
            <div className="grp">
              <InputGroup
                handleChange={(e) => setPlaka(e.target.value)}
                isRequired={false}
                labelText={"Plaka"}
                value={plaka}
                inputType={"text"}
                name={"plaka"}
                labelWidth={"200px"}
                inputWidth={"200px"}
                isSubmitted={false}
                requiredFields={[]}
              />
              <p>Plakayı arada boşluk bırakmadan yazınız.</p>
            </div>
            <div className="grp">
              <Button
                color={"#E85546"}
                background={"#0EAC00"}
                width="220px"
                radius={"10px"}
                padding="0 10px"
                handleClick={handleYetkiSorgula}
              >{
                  isLoadingGetAracYetkiSorgu ? (
                    <SmallSpinner
                      size={"20px"}
                      color={"#fff"}
                      bgColor={"#9ded9a"}
                    />
                  ) : (
                    "Yetki Belgesi Sorgula"
                  )
                }</Button>
            </div>
            <div className="grp">
              <Button
                color={"#E85546"}
                background={"#0EAC00"}
                width="220px"
                radius={"10px"}
                padding="0 10px"
                handleClick={handleMuayeneSorgula}
              >{
                  isLoadingGetAracMuayeneSorgu ? (
                    <SmallSpinner
                      size={"20px"}
                      color={"#fff"}
                      bgColor={"#9ded9a"}
                    />
                  ) : (
                    "Muayene Sorgula"
                  )
                }</Button>
              <p>Araç yetki belgesinde kayıtlı ise sorgulanabilir.</p>
            </div>
            <div className="grp">
              <Button
                color={"#E85546"}
                background={"#0EAC00"}
                width="220px"
                radius={"10px"}
                padding="0 10px"
                handleClick={handleCezaSorgula}
              >{
                  isLoadingGetAracCezaSorgu ? (
                    <SmallSpinner
                      size={"20px"}
                      color={"#fff"}
                      bgColor={"#9ded9a"}
                    />
                  ) : (
                    "Ceza Sorgula"
                  )
                }</Button>
              <p>
                Sadece Egeyurt Lojistik adına kesilen cezalar
                sorgulanabilmektedir.
              </p>
            </div>
          </div>
          {/* <div className="toplu-excel-container">
            <h3>Excel Listesinden Toplu Araç Yetki Belgesi Sorgulama</h3>
            <div className="input-grp">
              <label className="file-input-label" htmlFor="detayFile">
                Dosya Seç
              </label>
              <div className="file-name">{file.name || "Dosya Seçin"}</div>
              <input
                type="file"
                id="detayFile"
                className="file-input"
                onChange={(e) => setFile(e.target.files[0])}
              />
              <Button
                color={"#E85546"}
                background={"#0EAC00"}
                width="auto"
                radius={"10px"}
                padding="0 20px"
                handleClick={() => {}}
              >{
                  false ? (
                    <SmallSpinner
                      size={"20px"}
                      color={"#fff"}
                      bgColor={"#9ded9a"}
                    />
                  ) : (
                    "Toplu Yetki Belgesi Sorgula"
                  )
                }</Button>
            </div>
          </div> */}
        </div>
      </div>
    </Container>
  );
};

export default AraçYetkiBelgeSorgulamaUyelerVeAraclar;
